import { render, staticRenderFns } from "./events.vue?vue&type=template&id=1d088b94"
import script from "./events.ts?vue&type=script&lang=ts&external"
export * from "./events.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports